import { call, select, put, all, takeLatest } from "redux-saga/effects";
import { selectFormReqArrivingLateLeaveEarly } from "../redux/selector";
import { createReqArriveLateApi } from "core/http/service/timeKeeping";
import {
  createReqArriveLateFailed,
  createReqArriveLateStart,
  createReqArriveLateSuccess,
} from "../redux/createReqArriveLate";
import { toast } from "react-toastify";
import {
  formReqArrivingLateLeaveEarlyReset,
  resetFormLongTerm,
  TypeSelect,
} from "../redux/formReqArrivingLateLeaveEarly";

function* createReqArriveLateWork(action) {
  const { screenCode } = action.payload;
  const { data, longTerm } = yield select(selectFormReqArrivingLateLeaveEarly);

  try {
    const newFormData = {
      ...data,
      relatedPersonCodes: data?.relatedPersonCodes?.map((it) => it?.value),
      details: [
        ...(data?.type === TypeSelect.SHORT_TERM
          ? data?.details
              ?.filter((detail) => detail?.isNew && detail?.reasonCode)
              ?.map((it) => ({
                ...it,
                fromDate: it?.fromDate?.toISOString() ?? "",
                toDate: it?.toDate?.toISOString() ?? "",
              }))
          : [
              {
                fromDate: longTerm?.fromDate?.toISOString(),
                toDate: longTerm?.toDate?.toISOString(),
                minuteAmount: longTerm?.time,
                reasonCode: longTerm?.reason,
                type: longTerm?.typeReq,
              },
            ]),
      ],
    };
    const res = yield call(createReqArriveLateApi, newFormData, screenCode);

    if (res) {
      yield put({
        type: createReqArriveLateSuccess.type,
      });
      yield put({
        type: resetFormLongTerm.type,
      });
      yield put({
        type: formReqArrivingLateLeaveEarlyReset.type,
      });

      // yield put({
      //   type: getListArriveLateStart.type,
      //   payload: {
      //     year: moment().year(),
      //     month: moment().month() + 1,
      //     limit: 60,
      //     offset: 0,
      //     screenCode,
      //   },
      // });
      action.payload?.callback?.();
      toast.success("Đơn của bạn đã được gửi thành công!");
    }
  } catch (err: any) {
    yield put({
      type: createReqArriveLateFailed.type,
    });
    toast.error(
      err?.response?.data?.message || "Đã có lỗi xảy ra lúc tạo đơn!"
    );
  }
}

function* watchCreateReqArriveLate() {
  yield takeLatest(createReqArriveLateStart.type, createReqArriveLateWork);
}

export default function* createReqArriveLateSaga() {
  yield all([watchCreateReqArriveLate()]);
}
